const base = process.env.PUBLIC_URL || '';

export const CROWN_SRC = `${base}/images/swamp/page/Crown.png`;
export const BACKGROUND_PATTERN_SRC = `${base}/images/swamp/page/background-pattern.png`;

export function publicSrc(path: string): string {
   if (!path) {
      return '';
   }
   return path.startsWith('/') ? `${base}${path}` : path;
}
